/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「没有进度条的顶部标题栏」
 */
<template>
  <div class="cTopNoTitle-container">
    <p :style="{ width: width }">{{ titleName }}</p>
  </div>
</template>


<script>
export default {
  props: {
    percentNum: Number,
    titleName: String,
    width: String
  },
  data() {
    return {
      num: ''
    };
  },
  watch: {
    $route(to, from) {
      this.num = this.commonJs.getTopTitle(this.$route.path)
        ? this.commonJs.getTopTitle(this.$route.path).percentNum
        : 0;
    }
  },
  created() {
    this.num = this.commonJs.getTopTitle(this.$route.path)
      ? this.commonJs.getTopTitle(this.$route.path).percentNum
      : 0;
  },
  methods: {
    clickbtn() {
      this.$emit('clickbtn');
    }
  }
};
</script>

<style lang="less"  scoped>
.cTopNoTitle-container {
  height: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.2rem;
  background-color: #fff;
  p {
    font-size: 0.16rem;
    color: #333333;
    margin-left: 0.2rem;
    font-weight: bold;
    white-space: pre-line;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Title/cTopNoTitle.vue